import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IdeaService } from '../../services/idea.service';

@Component({
  selector: 'lib-share-idea-form',
  templateUrl: './share-idea-form.component.html',
  styleUrls: ['./share-idea-form.component.css'],
  standalone: false
})
export class ShareIdeaFormComponent {
  constructor(private ideaService: IdeaService) {}
  public ideaName: string;
  public ideaDescription: string;
  public showFileUpload = false;
  public files: File[];
  @Output()
  public formSubmitted = new EventEmitter();

  public submit() {
    this.formSubmitted.emit();
    this.ideaService
      .createIdea({
        name: this.ideaName,
        description: this.ideaDescription,
        createdBy: ''
      })
      .subscribe(result => {
        console.log(result);
        if (this.files != null && this.files.length > 0) {
          const id = result.id;
          this.ideaService.attachFilesToIdea(id, this.files).subscribe();
        }
      });
  }
  public onFileRemoved(file: File, fileInput?: HTMLInputElement) {
    if (fileInput != null) {
      const dt = new DataTransfer();
      for (let i = 0; i < this.files.length; i++) {
        if (this.files[i].name != file.name) {
          dt.items.add(this.files[i]);
        }
      }
      fileInput.files = dt.files;
    }
    this.files = this.files.filter(x => x.name !== file.name);
  }
  public onFileSelected(event) {
    this.files = Array.from(event.target.files);
  }
}
